import wNumb from "wnumb";

export default (decimals, suffix, column, i) => {
  const opts = {
    mark: ".",
    thousand: ",",
    suffix: suffix(column, i)
  };

  const decimalsNumber = decimals(column, i);

  if (decimals) {
    opts.decimals = decimalsNumber;
  }

  return wNumb(opts);
};
